import { Star } from "lucide-react";

export default function RatingPill({ score = 4.9, count = 294, className = "", testId = "rating-pill" }) {
  return (
    <a
      href="https://share.google/gmrVN5OsZBg1QRZcV"
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 shadow-sm hover:border-pink-200 transition-colors ${className}`}
      data-testid={testId}
    >
      <div className="flex">
        {[1,2,3,4,5].map(i => (
          <Star key={i} className="h-4 w-4 text-amber-500 fill-amber-500" />
        ))}
      </div>
      <span className="text-sm font-semibold text-slate-900">{score}</span>
      <span className="text-xs text-slate-500">({count} Google reviews)</span>
    </a>
  );
}
